import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MediasFacade } from '../facades/medias.facade';

export function mediasCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const facade = inject(MediasFacade);
        facade.clear();

        return true;
    };
}
